// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Owl Carousel v2.3.4
 * Copyright 2013-2018 David Deutsch
 * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE
 */
.owl-theme .owl-dots, .owl-theme .owl-nav {
	text-align: center;
	-webkit-tap-highlight-color: transparent
}
.owl-theme .owl-nav {
	margin-top: 10px
}
.owl-theme .owl-nav [class*=owl-] {
	color: #FFF;
	font-size: 14px;
	margin: 5px;
	padding: 4px 7px;
	background: #D6D6D6;
	display: inline-block;
	cursor: pointer;
	border-radius: 3px
}
.owl-theme .owl-nav [class*=owl-]:hover {
	background: #869791;
	color: #FFF;
	text-decoration: none
}
.owl-theme .owl-nav .disabled {
	opacity: .5;
	cursor: default
}
.owl-theme .owl-nav.disabled+.owl-dots {
	margin-top: 10px
}
.owl-theme .owl-dots .owl-dot {
	display: inline-block;
	zoom: 1
}
.owl-theme .owl-dots .owl-dot span {
	width: 10px;
	height: 10px;
	margin: 5px 7px;
	background: #D6D6D6;
	display: block;
	-webkit-backface-visibility: visible;
	transition: opacity .2s ease;
	border-radius: 30px
}
.owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {
	background: #869791
}
`, "",{"version":3,"sources":["webpack://./src/composant/css/owl.theme.default.min.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;CACC,kBAAkB;CAClB;AACD;AACA;CACC;AACD;AACA;CACC,WAAW;CACX,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,qBAAqB;CACrB,eAAe;CACf;AACD;AACA;CACC,mBAAmB;CACnB,WAAW;CACX;AACD;AACA;CACC,WAAW;CACX;AACD;AACA;CACC;AACD;AACA;CACC,qBAAqB;CACrB;AACD;AACA;CACC,WAAW;CACX,YAAY;CACZ,eAAe;CACf,mBAAmB;CACnB,cAAc;CACd,oCAAoC;CACpC,4BAA4B;CAC5B;AACD;AACA;CACC;AACD","sourcesContent":["/**\r\n * Owl Carousel v2.3.4\r\n * Copyright 2013-2018 David Deutsch\r\n * Licensed under: SEE LICENSE IN https://github.com/OwlCarousel2/OwlCarousel2/blob/master/LICENSE\r\n */\r\n.owl-theme .owl-dots, .owl-theme .owl-nav {\r\n\ttext-align: center;\r\n\t-webkit-tap-highlight-color: transparent\r\n}\r\n.owl-theme .owl-nav {\r\n\tmargin-top: 10px\r\n}\r\n.owl-theme .owl-nav [class*=owl-] {\r\n\tcolor: #FFF;\r\n\tfont-size: 14px;\r\n\tmargin: 5px;\r\n\tpadding: 4px 7px;\r\n\tbackground: #D6D6D6;\r\n\tdisplay: inline-block;\r\n\tcursor: pointer;\r\n\tborder-radius: 3px\r\n}\r\n.owl-theme .owl-nav [class*=owl-]:hover {\r\n\tbackground: #869791;\r\n\tcolor: #FFF;\r\n\ttext-decoration: none\r\n}\r\n.owl-theme .owl-nav .disabled {\r\n\topacity: .5;\r\n\tcursor: default\r\n}\r\n.owl-theme .owl-nav.disabled+.owl-dots {\r\n\tmargin-top: 10px\r\n}\r\n.owl-theme .owl-dots .owl-dot {\r\n\tdisplay: inline-block;\r\n\tzoom: 1\r\n}\r\n.owl-theme .owl-dots .owl-dot span {\r\n\twidth: 10px;\r\n\theight: 10px;\r\n\tmargin: 5px 7px;\r\n\tbackground: #D6D6D6;\r\n\tdisplay: block;\r\n\t-webkit-backface-visibility: visible;\r\n\ttransition: opacity .2s ease;\r\n\tborder-radius: 30px\r\n}\r\n.owl-theme .owl-dots .owl-dot.active span, .owl-theme .owl-dots .owl-dot:hover span {\r\n\tbackground: #869791\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
